import globalActions from '@/actions'
const state = {
	config: null
}
const mutations = {
  update: (state, data) => {
    state.config = data
	globalActions.setGlobalState({
		config: state
	});
  }
}
const actions = {
	async get({
		commit
	}) {
		if (state.data == null) {
			const consoleConfig = await fetch('/config.json?t=' + new Date().valueOf());
			let json =  await consoleConfig.json()
			commit('update',json)
		}
		return state;
	},
}
export default {
	namespaced: true,
	mutations,
	state,
	actions
}
